/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { allValid } from '../../utils';
import { createAppointment as apiCreateAppointment } from '../../api';

export const initState = {
    isLoading: false,
    error: null,
    isBooked: false,
};

export const createAppointment = createAsyncThunk(
    'bookingForm/createAppointment',
    // eslint-disable-next-line consistent-return
    async ({
        doctorId,
        timeslotId,
        body,
        baseUrl,
        isDoctoraOnline,
    }, { rejectWithValue }) => {
        try {
            const response = await (await apiCreateAppointment(doctorId, timeslotId, body, isDoctoraOnline))(baseUrl);
            return response.data;
        } catch (err) {
            rejectWithValue(err);
            throw err;
        }
    },
);

export const bookingFormSlice = createSlice({
    name: 'bookingForm',
    initialState: { ...initState },
    reducers: {
        clearDoctorBookingError: (state) => {
            state.error = null;
        },
        updateFormWithFormNameData: (
            state,
            {
                payload: {
                    formName,
                    data: { fields },
                },
            },
        ) => {
            const isNewFieldsValid = Object.hasData(fields) ? allValid(fields) : null;
            state[formName] = {
                fields,
                isFormValid: isNewFieldsValid,
            };
        },
        cleanBookingFormData: state => ({
            ...state,
            ...initState,
        }),
    },
    extraReducers: (builder) => {
        builder
            .addCase(createAppointment.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(createAppointment.fulfilled, (state, action) => {
                let startDateTime = null;
                let endDateTime = null;
                try {
                    startDateTime = new Date(action.payload?.startDateTime);
                    endDateTime = new Date(action.payload?.endDateTime);
                } catch (e) {
                    console.error('Error parsing date', e);
                }
                state.isBooked = true;
                state.isLoading = false;
                state.error = null;
                state.successBookingData = {
                    startDateTime,
                    endDateTime,
                    visitId: action?.payload?.visitId,
                };
            })
            .addCase(createAppointment.rejected, (state, { error }) => {
                state.isBooked = false;
                state.isLoading = false;
                state.error = error;
            });
    },
});

export const {
    updateFormWithFormNameData,
    cleanBookingFormData,
    clearDoctorBookingError,
} = bookingFormSlice.actions;

export default bookingFormSlice.reducer;
